import React from "react";
import { motion } from "framer-motion";
import { BENEFITS } from "../../data";

export const WhyUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="bg-white py-16 md:py-24 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-10 md:mb-14">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5 }}
            className="text-xs uppercase tracking-[0.24em] font-bold text-[#54BCE6] mb-4"
          >
            Why Home Pro Connect
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6 }}
            className="font-display text-[#133955] font-extrabold tracking-tighter text-4xl md:text-5xl leading-[0.98]"
          >
            A Simpler Way to Start a Major Home Project.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, delay: 0.08 }}
            className="mt-5 text-base md:text-lg text-[#173042]/75 max-w-2xl"
          >
            Finding the right type of contractor can be one of the most difficult parts of
            beginning a renovation. Home Pro Connect gives homeowners one clear place to
            explain the project and begin the connection process.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 auto-rows-fr">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            const dark = i % 2 === 1;
            return (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.07 }}
                data-testid={`benefit-card-${i}`}
                className={`group rounded-2xl p-7 md:p-8 border transition-transform duration-300 hover:-translate-y-1.5 ${
                  dark
                    ? "bg-[#133955] border-[#133955] text-white"
                    : "bg-[#EAF7FC] border-[rgba(19,57,85,0.06)] text-[#173042]"
                } ${i === BENEFITS.length - 1 ? "lg:col-span-1 md:col-span-2" : ""}`}
              >
                <span className={`grid place-items-center w-12 h-12 rounded-xl mb-5 ${dark ? "bg-[#54BCE6] text-[#133955]" : "bg-[#133955] text-white"}`}>
                  <Icon size={22} />
                </span>
                <h3 className={`font-display text-xl font-bold tracking-tight mb-2 ${dark ? "text-white" : "text-[#133955]"}`}>
                  {b.title}
                </h3>
                <p className={`text-[15px] leading-relaxed ${dark ? "text-white/75" : "text-[#173042]/75"}`}>
                  {b.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
